import { faCcAmex, faCcDiscover, faFacebookF, faGoogle, faCcMastercard, faCcVisa } from '@fortawesome/free-brands-svg-icons';
import { faAnalytics, faBell, faCashRegister, faBullhorn, faCalculator, faCalendarDay, faCalendarAlt, faCalendarStar, faTimes, faShoppingCart, faCheck, faClipboardListCheck, faCopy, faCreditCardFront, faEdit, faEnvelope, faEnvelopeOpenText, faFileExport, faEye, faFilter, faGift, faGlobe, faQuestionCircle, faHome, faLink, faLock, faMapMarkerAlt, faChartBar, faMicrophoneAlt, faMinusCircle, faMobileAlt, faBuilding, faPhone, faPiggyBank, faPlug, faPlusCircle, faReceipt, faFileChartLine, faBarcodeRead, faSearch, faChair, faShare, faSortAlt, faUsersCrown, faThumbsDown, faThumbsUp, faUnlock, faUpload, faUser, faUsers, faLandmark, faTag } from '@fortawesome/pro-light-svg-icons';
import { faAnalytics as faAnalytics$1, faCalendarStar as faCalendarStar$1, faCreditCardFront as faCreditCardFront$1, faUsdSquare, faKey, faLongArrowRight, faQuestionSquare, faFileChartLine as faFileChartLine$1, faSortAlt as faSortAlt$1, faUsersCrown as faUsersCrown$1, faArrowAltSquareUp, faTag as faTag$1 } from '@fortawesome/pro-solid-svg-icons';
import { faAngleDown, faAngleUp, faUserFriends, faBold, faCalculator as faCalculator$1, faCalendarDay as faCalendarDay$1, faCheck as faCheck$1, faGlassCheers, faClipboardList, faCrown, faTrash, faDollarSign, faArrowAltDown, faFileDownload, faCode, faUsdSquare as faUsdSquare$1, faFilter as faFilter$1, faFire, faGift as faGift$1, faGlobe as faGlobe$1, faGlobeAmericas, faChartLine, faItalic, faKey as faKey$1, faArrowLeft, faChevronLeft, faLink as faLink$1, faLongArrowRight as faLongArrowRight$1, faListOl, faPlus, faPrint, faFileChartLine as faFileChartLine$2, faArrowRight, faChevronRight, faSearch as faSearch$1, faCog, faSignOut, faStream, faSync, faTicketAlt, faListUl, faUnderline, faUnlock as faUnlock$1, faArrowAltUp, faMegaphone, faArrowAltSquareUp as faArrowAltSquareUp$1, faUsers as faUsers$1, faEllipsisV, faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { faAngleDown as faAngleDown$1, faAngleUp as faAngleUp$1, faUserFriends as faUserFriends$1, faArrowLeft as faArrowLeft$1, faCashRegister as faCashRegister$1, faBullhorn as faBullhorn$1, faCalculator as faCalculator$2, faCalendarDay as faCalendarDay$2, faCalendarWeek, faTimes as faTimes$1, faTimesCircle, faCaretDown, faMoneyBill, faCheckCircle, faUserTie, faCopy as faCopy$1, faCreditCard, faCrown as faCrown$1, faICursor, faTrash as faTrash$1, faEnvelope as faEnvelope$1, faEye as faEye$1, faGlobe as faGlobe$2, faGlobeAmericas as faGlobeAmericas$1, faQuestionCircle as faQuestionCircle$1, faHome as faHome$1, faInfoCircle, faChevronLeft as faChevronLeft$1, faLock as faLock$1, faBars, faChartBar as faChartBar$1, faMicrophoneAlt as faMicrophoneAlt$1, faMobileAlt as faMobileAlt$1, faBuilding as faBuilding$1, faPause, faPiggyBank as faPiggyBank$1, faPlug as faPlug$1, faPlus as faPlus$1, faPlusCircle as faPlusCircle$1, faPrint as faPrint$1, faReceipt as faReceipt$1, faChevronCircleRight, faChevronRight as faChevronRight$1, faSearch as faSearch$2, faChair as faChair$1, faCog as faCog$1, faShare as faShare$1, faSort, faStar, faThumbsDown as faThumbsDown$1, faThumbsUp as faThumbsUp$1, faTicketAlt as faTicketAlt$1, faUpload as faUpload$1, faUserCircle, faUser as faUser$1, faUsers as faUsers$2, faLandmark as faLandmark$1, faExclamationTriangle as faExclamationTriangle$1 } from '@fortawesome/free-solid-svg-icons';
import { faCalendarAlt as faCalendarAlt$1, faComments, faClock, faCopy as faCopy$2, faEdit as faEdit$1, faEye as faEye$2, faEyeSlash, faLifeRing, faQuestionCircle as faQuestionCircle$2, faSadTear, faUser as faUser$2 } from '@fortawesome/free-regular-svg-icons';

var IconEnum = {
    Amex: faCcAmex,
    Discover: faCcDiscover,
    FacebookPlain: faFacebookF,
    Google: faGoogle,
    Mastercard: faCcMastercard,
    Visa: faCcVisa,
    AnalyticsLight: faAnalytics,
    BellLight: faBell,
    BoxOfficeLight: faCashRegister,
    BullHornLight: faBullhorn,
    CalculatorLight: faCalculator,
    CalendarDayLight: faCalendarDay,
    CalendarLight: faCalendarAlt,
    CalendarStarLight: faCalendarStar,
    CancelLight: faTimes,
    CartLight: faShoppingCart,
    CheckLight: faCheck,
    ClipboardLight: faClipboardListCheck,
    CopyLight: faCopy,
    CreditCardFrontLight: faCreditCardFront,
    EditLight: faEdit,
    EnvelopeLight: faEnvelope,
    EnvelopeOpenRegular: faEnvelopeOpenText,
    ExportLight: faFileExport,
    EyeLight: faEye,
    FilterLight: faFilter,
    GiftLight: faGift,
    GlobeLinesLight: faGlobe,
    HelpLight: faQuestionCircle,
    HomeLight: faHome,
    LinkLight: faLink,
    Lock: faLock,
    MapPinLight: faMapMarkerAlt,
    MetricsLight: faChartBar,
    MicrophoneLight: faMicrophoneAlt,
    MinusCircleLight: faMinusCircle,
    MobileLight: faMobileAlt,
    OrganizationLight: faBuilding,
    PhoneLight: faPhone,
    PiggyBankLight: faPiggyBank,
    PlugLight: faPlug,
    PlusCircleLight: faPlusCircle,
    ReceiptLight: faReceipt,
    ReportLight: faFileChartLine,
    Scan: faBarcodeRead,
    SearchLight: faSearch,
    SeatingLight: faChair,
    ShareLight: faShare,
    SortByLight: faSortAlt,
    TeamLight: faUsersCrown,
    ThumbsDownLight: faThumbsDown,
    ThumbsUpLight: faThumbsUp,
    UnlockLight: faUnlock,
    UploadLight: faUpload,
    UserLight: faUser,
    UsersLight: faUsers,
    VenueLight: faLandmark,
    AnalyticsSolid: faAnalytics$1,
    CalendarStarSolid: faCalendarStar$1,
    CreditCardFront: faCreditCardFront$1,
    FeeSolid: faUsdSquare,
    KeySolid: faKey,
    LongRightArrow: faLongArrowRight,
    QuestionSquareSolid: faQuestionSquare,
    ReportSolid: faFileChartLine$1,
    SortBy: faSortAlt$1,
    TeamSolid: faUsersCrown$1,
    UpgradeSolid: faArrowAltSquareUp,
    AngleDownRegular: faAngleDown,
    AngleUpRegular: faAngleUp,
    AudienceRegular: faUserFriends,
    BoldRegular: faBold,
    CalculatorRegular: faCalculator$1,
    CalendarDayRegular: faCalendarDay$1,
    CheckRegular: faCheck$1,
    Cheers: faGlassCheers,
    Clipboard: faClipboardList,
    CrownRegular: faCrown,
    DeleteRegular: faTrash,
    Dollar: faDollarSign,
    DownArrow: faArrowAltDown,
    DownloadReport: faFileDownload,
    Embed: faCode,
    FeeRegular: faUsdSquare$1,
    FilterRegular: faFilter$1,
    FireRegular: faFire,
    GiftRegular: faGift$1,
    GlobeLinesRegular: faGlobe$1,
    GlobeRegular: faGlobeAmericas,
    GraphGrowth: faChartLine,
    ItalicRegular: faItalic,
    KeyRegular: faKey$1,
    LeftArrowRegular: faArrowLeft,
    LeftChevronRegular: faChevronLeft,
    LinkRegular: faLink$1,
    LongRightArrowRegular: faLongArrowRight$1,
    OListRegular: faListOl,
    PlusRegular: faPlus,
    PrintRegular: faPrint,
    ReportRegular: faFileChartLine$2,
    RightArrowRegular: faArrowRight,
    RightChevronRegular: faChevronRight,
    SearchRegular: faSearch$1,
    SettingsRegular: faCog,
    SignOut: faSignOut,
    StreamRegular: faStream,
    SyncRegular: faSync,
    TicketRegular: faTicketAlt,
    UListRegular: faListUl,
    UnderlineRegular: faUnderline,
    UnlockRegular: faUnlock$1,
    UpArrow: faArrowAltUp,
    Update: faMegaphone,
    UpgradeRegular: faArrowAltSquareUp$1,
    UsersRegular: faUsers$1,
    VerticalEllipsisRegular: faEllipsisV,
    WarningRegular: faExclamationTriangle,
    AngleDownSolid: faAngleDown$1,
    AngleUpSolid: faAngleUp$1,
    AudienceSolid: faUserFriends$1,
    BackArrow: faArrowLeft$1,
    BoxOfficeSolid: faCashRegister$1,
    BullhornSolid: faBullhorn$1,
    CalculatorSolid: faCalculator$2,
    CalendarDaySolid: faCalendarDay$2,
    CalendarWeekSolid: faCalendarWeek,
    Cancel: faTimes$1,
    CancelCircle: faTimesCircle,
    CaretDown: faCaretDown,
    Cash: faMoneyBill,
    CheckCircle: faCheckCircle,
    ContactSolid: faUserTie,
    CopySolid: faCopy$1,
    CreditCardBack: faCreditCard,
    CrownSolid: faCrown$1,
    Cursor: faICursor,
    DeleteSolid: faTrash$1,
    EnvelopeSolid: faEnvelope$1,
    EyeSolid: faEye$1,
    GlobeLinesSolid: faGlobe$2,
    GlobeSolid: faGlobeAmericas$1,
    HelpSolid: faQuestionCircle$1,
    HomeSolid: faHome$1,
    InfotipSolid: faInfoCircle,
    LeftArrowSolid: faArrowLeft$1,
    LeftChevronSolid: faChevronLeft$1,
    LockSolid: faLock$1,
    Menu: faBars,
    MetricsSolid: faChartBar$1,
    MicrophoneSolid: faMicrophoneAlt$1,
    MobileSolid: faMobileAlt$1,
    OrganizationSolid: faBuilding$1,
    PauseSolid: faPause,
    PiggyBankSolid: faPiggyBank$1,
    PlugSolid: faPlug$1,
    Plus: faPlus$1,
    PlusCircle: faPlusCircle$1,
    PrintSolid: faPrint$1,
    ReceiptSolid: faReceipt$1,
    RightChevronCircle: faChevronCircleRight,
    RightChevronSolid: faChevronRight$1,
    SearchSolid: faSearch$2,
    SeatingSolid: faChair$1,
    SettingsSolid: faCog$1,
    ShareSolid: faShare$1,
    Sort: faSort,
    StarSolid: faStar,
    ThumbsDownSolid: faThumbsDown$1,
    ThumbsUpSolid: faThumbsUp$1,
    TicketSolid: faTicketAlt$1,
    UploadSolid: faUpload$1,
    UserCircle: faUserCircle,
    UserSolid: faUser$1,
    UsersSolid: faUsers$2,
    VenueSolid: faLandmark$1,
    Warning: faExclamationTriangle$1,
    CalendarRegular: faCalendarAlt$1,
    ChatRegular: faComments,
    Clock: faClock,
    CopyRegular: faCopy$2,
    Edit: faEdit$1,
    EyeRegular: faEye$2,
    EyeSlashRegular: faEyeSlash,
    Help: faLifeRing,
    HelpRegular: faQuestionCircle$2,
    SadTear: faSadTear,
    UserRegular: faUser$2,
    CreditCardBackLight: faCreditCard,
    TagLight: faTag,
    TagSolid: faTag$1,
};

export { IconEnum };
//# sourceMappingURL=Icons.js.map
